module.exports = "/assets/data/ec75939a88227dc3dc8192d4deb30b3b-EH41.data.json";